<template>
  <div>
    <b-dropdown  id="no-pr" class="float-and-padding-profile-menu" right variant="transparent" v-if="!anonym">
      <template #button-content>
        <b-icon-star-fill v-if="isUserModeExpert"/> {{username}}
      </template>
      <!--        <b-nav-item >-->
      <!--            {{ username }}-->
      <!--        </b-nav-item>-->
      <!--        <template v-slot:button-content>-->
      <!--                {{ username }}-->
      <!--        </template>-->

      <b-dropdown-item  href="#" v-on:click="$bvModal.show('configureProfileModal')" v-if="!anonym && !kunde">
        <b-icon-gear-fill/>
        {{ $t('header.configureProfile') }}
      </b-dropdown-item>
      <b-dropdown-item v-if="!extern && !anonym" href="#" v-on:click="$bvModal.show('resetCachesModal')">
        <b-icon-arrow-repeat/>
        {{ $t('header.resetCaches') }}
      </b-dropdown-item>
      <b-dropdown-item v-if="extern && !anonym && !kunde" :href="partnerNetworkURL">
        <b-icon-people/>
        {{ $t('header.partnerNetwork') }}
      </b-dropdown-item>
      <b-dropdown-item v-if="extern && !anonym" :href="resetPasswordURL" target="_blank">
        <b-icon-wrench/>
        {{ $t('header.resetPassword') }}
      </b-dropdown-item>
      <b-dropdown-divider v-if="!extern && anonym"/>
      <b-dropdown-item v-if="extern && !anonym" :href="logoutURL">
        <b-icon-box-arrow-right/>
        {{ $t('header.logOut') }}
      </b-dropdown-item>
    </b-dropdown>
  </div>
</template>

<script>
import url from "@/rest/url";

export default {
  name: "ProfileMenu",
  props: ['csrfToken'],
  methods: {
    logout: function() {
      this.$refs.logoutForm.submit();
    },
  },
  computed: {
    username: function () {
      return this.$store.getters.getUserData.displayName;
    },

    extern: function() {
      return this.$store.getters.getUserData.extern;
    },

    kunde: function() {
      return this.$store.getters.getUserData.kunde;
    },

    anonym: function() {
      return this.$store.getters.getUserData.anonym;
    },

    partnerNetworkURL() {
      return url.partnerNetworkURL;
    },

    resetPasswordURL() {
      return url.resetPasswordURL;
    },

    logoutURL() {
      return url.logoutURL;
    },
    isUserModeExpert: function (){
      let mode = this.$store.getters.getUserData.defaultModus;
      if(mode === undefined) {
        //wenn userdata nicht geladen ist => standardmodus rein
        return false
      } else {
        return mode.includes('EXPERT') ? true : false
      }
    }
  }
}
</script>

<style scoped>
/deep/ #no-pr > button{
  padding: 0px;
}
</style>